import { useGlobalStore } from '../store/global'
import { useTokenStore } from "../store/token";

import rightsMatrix from './rights_matrix.json';

export default defineNuxtPlugin((nuxtApp) => {

  const tokenStore = useTokenStore();
  const store = useGlobalStore();

  const isUserFromUS = computed(() => {
    return store.countries.data.find(it => it.id == store.user.country_id).code_iso === 'US';
  });

  // const matrix = JSON.parse

  /*nuxtApp.vueApp.config.errorHandler = (error, context) => {
    console.log("GLOBAL ERROR", error, context)
    showError(error)

  }*/

  function slugify(text) {
    if (!text) return "";

    const slug = text
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9]/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");

    return slug.toLowerCase();
  }

  function convertDimensions(dimensions) {
    if (isUserFromUS.value) {
      const dimensionsArray = dimensions.split('x').map(dim => {
        if (dim.trim() === 'undefined') {
          return 'undefined';
        }
        return (parseFloat(dim) * 0.393701).toFixed(2);
      });
      return dimensionsArray.join(' x ').concat(' in');
    }
    return dimensions;
  }

  function convertWeight(weight) {
    if (isUserFromUS.value) {
      return (parseFloat(weight) * 2.20462).toFixed(2).concat(' lbs');
    }
    return weight;
  }

  nuxtApp.provide('slugify', slugify);
  nuxtApp.provide('isUserFromUS', isUserFromUS);
  nuxtApp.provide('convertDimensions', convertDimensions);
  nuxtApp.provide('convertWeight', convertWeight);

  // You can alternatively use this format, which comes with automatic type support
  return {

    provide: {

      getRightsMatrix(status: string, action: string) {
        return (status && action) ? rightsMatrix[store.user.role][status][action] : 0
      },

      getStatusColor(status: string) {
        switch (status) {
          case "DRAFT":
            return "#5253FF";
          case "TO REVIEW":
            return "#4B8380";
          case "QUOTE":
            return "#4dc3be";
          case "ORDER FORM":
            return "#F05818";
          case "CLOSED":
            return "#723813";
          case "ENDED":
            return "#7f00ff";
          case "CANCELLED":
            return "#393939";
          default:
            return "#E0E0E0";
        }
      },

      capitalize(string: string) {
        return string[0].toUpperCase() + string.slice(1).toLowerCase()
      },

      formatPrice(currency_code: string, price: number) {
        const priceFormatter = new Intl.NumberFormat(store.parameters.locale,
          { style: "currency", currency: currency_code })

        return priceFormatter.format(price).replace(/\u202f/g, '\xa0')
      },

      discount(ttPrice: number, discount: number, vat: number, tax_exemption: boolean) {

        var price = tax_exemption ? ttPrice / (1 + vat) : ttPrice
        return price - price * (1 - discount / 100)
      },


      isUserRoleGreaterThan(role: string) {

        if (!store || !store.user || !store.user.role) {
          return false
        }

        const user_role = store.user.role

        if (role == 'sales_associate_front') {
          return user_role == "admin"
            || user_role == "regional_manager"
            || user_role == "store_manager"
            || user_role == "sales_associate_back"
            || user_role == "sales_associate_front"
        }
        if (role == 'sales_associate_back') {
          return user_role == "admin"
            || user_role == "regional_manager"
            || user_role == "store_manager"
            || user_role == "sales_associate_back"
        }
        if (role == 'store_manager') {
          return user_role == "admin"
            || user_role == "regional_manager"
            || user_role == "store_manager"
        }
        if (role == 'regional_manager') {
          return user_role == "admin"
            || user_role == "regional_manager"
        }
        if (role == 'admin') {
          return user_role == "admin"
        }
        return false
      },

      getNextStatus(status: string) {
        switch (status) {
          case "DRAFT":
            return "TO REVIEW"
          case "TO REVIEW":
            return "QUOTE"
          case "QUOTE":
            return "ORDER FORM"
          case "ORDER FORM":
            return "CLOSED"
          case "CLOSED":
            return "ENDED"
        }
        return "unknown"
      },

      canEdit: (status: string) => {
        switch (status) {
          case "DRAFT":
            return nuxtApp.$isUserRoleGreaterThan('sales_associate_front')
          case "TO REVIEW":
            return nuxtApp.$isUserRoleGreaterThan('sales_associate_back')
          case "QUOTE":
            return nuxtApp.$isUserRoleGreaterThan('sales_associate_back')
          case "ORDER FORM":
            return nuxtApp.$isUserRoleGreaterThan('sales_associate_back')
          case "CLOSED":
            return false
          case "ENDED":
            return false
          case "CANCELLED":
            return false
        }
      },

      getParameter(key: string, lang: string = "") {
        lang = lang.length ? lang : store.language
        let label = store.parameters && store.parameters.labels ? store.parameters.labels[key] : ""
        return label ? (
          label[lang] ? label[lang] :
            (label["en"] ? label["en"] : key)
        ) : key
      },

      getTranslation: (input: any) => {
        let obj = null
        if (typeof input == "string") {
          try {
            obj = JSON.parse(input);
          } catch (e) {
            return input;
          }
        } else {
          obj = input
        }
        return obj ? (
          obj[store.language] ? obj[store.language] :
            (obj["en"] ? obj["en"] : "---")
        ) : "---"
      },

      getInCurrency: (currency_code: string, input: any) => {
        let obj = null
        if (typeof input == "string") {
          try {
            obj = JSON.parse(input);
          } catch (e) {
            return "---";
          }
        } else {
          obj = input
        }

        return (obj && obj[currency_code]) ? obj[currency_code] : "---"
      },

      formatIsoDate(isoString: string) {
        const date = new Date(isoString);
        const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
        const locale = store.language === "en" ? "en-EN" : "fr-FR";

        return date.toLocaleDateString(locale, options);
      },

      snackbar: (type: String, text: String) => {
        return {
          display: true, text: text, color: type, icon: "$" + type
        }

      },

      get: (route: string) => {
        return useFetch(route, {
          method: "GET",
          baseURL: store.apiBase,
          headers: { Authorization: "Bearer " + tokenStore.currentValue }
        });
      },

      post: (route: string, body: any) => {
        return useFetch(route, {
          method: "POST",
          baseURL: store.apiBase,
          headers: { Authorization: "Bearer " + tokenStore.currentValue },
          body: body
        });
      },

      patch: (route: string, id: string, body: any) => {
        return useFetch(route + "/" + id, {
          method: "PATCH",
          baseURL: store.apiBase,
          headers: { Authorization: "Bearer " + tokenStore.currentValue },
          body: body
        })

      },

      delete: (route: string, id: string) => {
        return useFetch(route + "/" + id, {
          method: "DELETE",
          baseURL: store.apiBase,
          headers: { Authorization: "Bearer " + tokenStore.currentValue }
        });
      },
    }
  }
})
/*
export default (context, inject) => {
  function getTranslation(obj, key) {
    console.log("translate ", key, context.store.state);
    var trans = obj[key + context.store.state.language];
    trans = trans ? trans : obj[key];
    return trans ? nl2br(trans) : "no value";
  }
  inject('getTranslation', getTranslation);

  function isEmptyTranslation(obj, key) {
    var trans = obj[key + context.store.state.suffix_lang];
    trans = trans ? trans : obj[key];
    return !trans || trans.length == 0;
  }
  inject('isEmptyTranslation', isEmptyTranslation);


  function nl2br(str, is_xhtml=false) {

    if (typeof str === 'undefined' || str === null) {
      return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    //return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    return (str + '').replace(/\r\n|\n\r|\r|\n/g, breakTag);
  }
  inject('nl2br', nl2br);
}*/
